import { memo, useEffect } from 'react';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import cn from 'classnames';
import { useAsyncFn } from '@zmedia/bm-soccer-ui/hooks';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import PageService from '@zmedia/bm-soccer-ui/service/PageService';
import LiveService from '@zmedia/bm-soccer-ui/service/LiveService';
import {
    Columns,
    Element,
    RouterLink,
    Section,
} from '@zmedia/bm-soccer-ui/components';
import { RankingSidebar } from '@zmedia/bm-soccer-ui/layout/sidebar/right';
import { URL_SOCCER_PAGE } from '../shared';
import { Group } from '../group';
import { DateChange } from './components';
import Empty from '../shared/components/Empty';
import styles from './style.module.scss';


function LiveScoreView(props: any) {
    let data = props;
    const router = useRouter();
    const date = router.query.date;
    const isLive = router.asPath === URL_SOCCER_PAGE.LIVE;

    if (ObjectUtils.isEmpty(data)) {
        const [state, callback] = useAsyncFn(PageService.getMatches);

        useEffect(() => {
            callback({ date: date });
        }, [date]);

        data = state.value?.data || {};
    }

    if (ObjectUtils.isEmpty(data)) {
        return null;
    }

    return (
        <Columns className={styles['column-home']}>
            <Columns.Column type="main">
                <Section>
                    <Element className={styles['livesoccer-header']}>
                        <RouterLink
                            to={
                                router.asPath === URL_SOCCER_PAGE.LIVE
                                    ? URL_SOCCER_PAGE.LIVESCORE
                                    : URL_SOCCER_PAGE.LIVE
                            }
                            className={cn(styles['live-btn'], {
                                [styles['is-live']]: isLive,
                            })}
                        >
                            <Element renderAs="h2">Live</Element>
                        </RouterLink>
                        <DateChange date={data.date} isLive={isLive} />
                    </Element>
                    {isLive ? (
                        <LiveView />
                    ) : (
                        <Group groups={data.sections}></Group>
                    )}
                </Section>
            </Columns.Column>
            <Columns.Column type="sub">
                <RankingSidebar
                    className={styles['home-ranking']}
                    name={'Ngoại Hạng Anh'}
                    id={1}
                    data={props.rankingSidebar}
                />
            </Columns.Column>
        </Columns>
    );
}

function LiveView() {
    const state = useAsync(LiveService.getMatches);
    const data = state.value?.data || {};

    if (ObjectUtils.isEmpty(data)) {
        return <Empty content="Chưa có trận đấu đang diễn ra"></Empty>;
    }

    return <Group groups={data.sections}></Group>;
}
export default memo(LiveScoreView);
